import { render } from "./ProductosRecomendados.vue?vue&type=template&id=79177ba0"
import script from "./ProductosRecomendados.vue?vue&type=script&lang=js"
export * from "./ProductosRecomendados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__